// This file is AUTOGENERATED, do not edit it manually!!!

export const taskDetails = {
    BillingTypeNotBillable: 'Non fatturabile',
    BillingTypeProjectBillingSettings: 'Impostazioni di fatturazione del progetto',
    DayPluralFormat: '1#{0} giorno#{0} giorni',
    Days: '({0}g)',
    issue: 'Problema',
    project: 'Progetto',
    request: 'Richiesta',
    task: 'Compito',
    today: 'Oggi',
};
